
window.CartSamples = {
  checkCartItems: null,
  initializeEventListeners: null,
  openSamplesDrawer: null,
  closeSamplesDrawer: null
};

document.addEventListener('DOMContentLoaded', function() {
  let selectedSamples = new Set();
  const maxSamples = window.maxSamples || 0;
  const limitSamplesEnabled = window.limitSamplesEnabled || false;
  let samplesInCart = 0;

  function updateConfirmButton() {
    const confirmButtons = document.querySelectorAll('.samples-panel__sample-button-atc');
    confirmButtons.forEach(button => {
      if (selectedSamples.size === 0) {
        button.classList.add('disabled');
      } else {
        button.classList.remove('disabled');
      }
    });
  }

  function countSamplesInCart(cartData) {
    if (!limitSamplesEnabled) return 0;
    
    const sampleProductIds = window.sampleProductIds || [];
    let count = 0;
    
    // Convert sampleProductIds to numbers for comparison
    const sampleProductIdsNum = sampleProductIds.map(id => parseInt(id, 10)).filter(id => !isNaN(id));
    
    cartData.items.forEach(item => {
      const itemProductId = parseInt(item.product_id, 10);
      // Check if this item's product_id matches any sample product ID
      if (sampleProductIdsNum.includes(itemProductId)) {
        count += item.quantity;
      }
    });
    
    return count;
  }

  function updateSampleButtonStates() {
    if (!limitSamplesEnabled) {
      // If limit is not enabled, ensure all buttons are enabled (except in-cart and sold-out)
      document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
        const isInCart = button.classList.contains('in-cart');
        const isSoldOut = button.classList.contains('sold-out');
        if (!isInCart && !isSoldOut) {
          button.classList.remove('limit-reached');
          button.closest('.samples-panel__sample')?.classList.remove('limit-reached');
          button.disabled = false;
        }
      });
      return;
    }
    
    const remainingSlots = maxSamples - samplesInCart;
    const canSelectMore = selectedSamples.size < remainingSlots;
    
    document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
      const variantId = button.dataset.variantId;
      const isSelected = selectedSamples.has(variantId);
      const isInCart = button.classList.contains('in-cart');
      const isSoldOut = button.classList.contains('sold-out');
      
      // Remove limit-reached class first
      button.classList.remove('limit-reached');
      button.closest('.samples-panel__sample')?.classList.remove('limit-reached');
      
      // If button is already in cart or sold out, skip
      if (isInCart || isSoldOut) {
        return;
      }
      
      // If limit is reached and button is not selected, disable it
      if (!canSelectMore && !isSelected) {
        button.classList.add('limit-reached');
        button.closest('.samples-panel__sample')?.classList.add('limit-reached');
        button.disabled = true;
      } else {
        // Enable button if it's selected or if we can still select more
        button.disabled = false;
      }
    });
  }

  async function checkAndRemoveSampleProducts(cartData) {
    try {
     
      
  
      const sampleProductIds = window.sampleProductIds || [];
      
      
      if (sampleProductIds.length === 0) {
       
        return;
      }

 
      const sampleItems = [];
      const nonSampleItems = [];
      
      cartData.items.forEach((item, index) => {
       
        
        if (sampleProductIds.includes(item.product_id)) {
          sampleItems.push({...item, line: index + 1});
        } else {
          nonSampleItems.push({...item, line: index + 1});
        }
      });

   

     
      if (sampleItems.length > 0 && nonSampleItems.length === 0) {
      
        
  
        const sortedSampleItems = sampleItems.sort((a, b) => b.line - a.line);
        
        for (const sampleItem of sortedSampleItems) {
          try {
           
            
            const removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: sampleItem.line,
                quantity: 0
              })
            });

            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
            
          
              const cartErrors = document.querySelectorAll('#CartDrawer-CartErrors, [data-shopify-cart-errors], .cart-item__error');
              cartErrors.forEach(error => error.style.display = 'none');
            } else {
              const responseData = await removeResponse.json();
            
            }
          } catch (error) {
           
          }
        }


        try {
         
          
    
          const freshCartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          const freshCartData = await freshCartResponse.json();
         
        
       
          setTimeout(() => {
            window.location.reload();
          }, 500);
          return;
          
        } catch (error) {
        
        }
      } else {
       
      }
    } catch (error) {
     
    }
  }

  async function checkCartItems() {
    try {
    
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await response.json();
     
      const cartVariantIds = new Set(cartData.items.map(item => item.variant_id.toString()));
     
      // Count samples already in cart - do this first with fresh data
      samplesInCart = countSamplesInCart(cartData);

  
      await checkAndRemoveSampleProducts(cartData);

      // Fetch fresh cart data after potential removals to ensure accurate count
      const freshResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const freshCartData = await freshResponse.json();
      const freshCartVariantIds = new Set(freshCartData.items.map(item => item.variant_id.toString()));
      
      // Recalculate samples in cart with fresh data
      samplesInCart = countSamplesInCart(freshCartData);

   
      document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
        const variantId = button.dataset.variantId;
       
        button.classList.remove('in-cart', 'selected', 'sold-out', 'limit-reached');
        button.disabled = false;
        button.textContent = 'Select Sample';
        button.closest('.samples-panel__sample')?.classList.remove('in-cart', 'sold-out', 'limit-reached');
        selectedSamples.delete(variantId);
      });

      // Process all buttons and wait for async operations to complete
      const buttonPromises = Array.from(document.querySelectorAll('.samples-panel__sample-button')).map(async (button) => {
        const variantId = button.dataset.variantId;
      
        if (freshCartVariantIds.has(variantId)) {
          button.classList.add('in-cart');
          button.closest('.samples-panel__sample')?.classList.add('in-cart');
          button.disabled = true;
          button.textContent = 'In Cart';
        } else {
         
          try {
            const variantResponse = await fetch(`/products.json?limit=1&ids=${button.dataset.productId}`);
            const productData = await variantResponse.json();
            
            if (productData.products && productData.products.length > 0) {
              const product = productData.products[0];
              const variant = product.variants.find(v => v.id.toString() === variantId);
              
              if (variant && !variant.available) {
                button.classList.add('sold-out');
                button.closest('.samples-panel__sample')?.classList.add('sold-out');
                button.disabled = true;
                button.textContent = 'Sold Out';
              }
            }
          } catch (error) {
            console.error('Error checking variant availability:', error);
          }
        }
      });

      // Wait for all async operations to complete
      await Promise.all(buttonPromises);

      // Recalculate samplesInCart after buttons are updated
      // Count unique variant IDs with 'in-cart' class (not total buttons, since mobile/desktop have duplicates)
      if (limitSamplesEnabled) {
        const inCartButtons = document.querySelectorAll('.samples-panel__sample-button.in-cart');
        const uniqueVariantIds = new Set();
        inCartButtons.forEach(button => {
          const variantId = button.dataset.variantId;
          if (variantId) {
            uniqueVariantIds.add(variantId);
          }
        });
        samplesInCart = uniqueVariantIds.size;
      }

      // Update button states based on limit - now with accurate samplesInCart
      updateSampleButtonStates();
      updateProgress();
      updateConfirmButton();
      

      return Promise.resolve();
    } catch (error) {
     
      return Promise.reject(error);
    }
  }

  function updateProgress() {
    const selectedCount = selectedSamples.size;
    const totalSamples = limitSamplesEnabled ? (samplesInCart + selectedCount) : selectedCount;
    const displayMax = limitSamplesEnabled ? maxSamples : maxSamples;
    const percentage = displayMax > 0 ? (totalSamples / displayMax) * 100 : 0;
   
    
    document.querySelectorAll('.samples-panel-progress__text').forEach(text => {
      if (limitSamplesEnabled && samplesInCart > 0) {
        text.textContent = `${totalSamples}/${displayMax} Selected (${samplesInCart} in cart)`;
      } else {
        text.textContent = `${selectedCount}/${displayMax} Selected`;
      }
    });
    
    document.querySelectorAll('.samples-panel-progress__bar-fill').forEach(bar => {
     
      bar.style.width = `${percentage}%`;
     
    });
  }

  function openSamplesDrawer() {
   
    document.querySelectorAll('.samples-panel-mobile, .samples-panel-desktop').forEach(panel => {
      panel.classList.add('is-open');
    });
  }

  function closeSamplesDrawer() {
    document.querySelectorAll('.samples-panel-mobile, .samples-panel-desktop').forEach(panel => {
      panel.classList.remove('is-open');
    });
  }

  function handleSampleButtonClick(button) {
    
    // Allow deselection even if limit is reached
    const isSelected = button.classList.contains('selected');
    if (!isSelected && (button.classList.contains('in-cart') || button.classList.contains('sold-out') || button.classList.contains('limit-reached'))) {
      return;
    }
    
    const variantId = button.dataset.variantId;
    
    if (!variantId) {
      console.error('No variant ID found on sample button');
      return;
    }
    
    if (isSelected) {
      selectedSamples.delete(variantId);
      button.classList.remove('selected');
      button.textContent = 'Select Sample';
    } else {
      // Check if we can select more samples
      let canSelect = true;
      if (limitSamplesEnabled) {
        const remainingSlots = maxSamples - samplesInCart;
        canSelect = selectedSamples.size < remainingSlots;
      } else {
        canSelect = selectedSamples.size < maxSamples;
      }
      
      if (canSelect) {
        selectedSamples.add(variantId);
        button.classList.add('selected');
        button.textContent = 'Selected';
      }
    }
    
    updateSampleButtonStates();
    updateProgress();
    updateConfirmButton();
  }

  async function handleConfirmSelection() {
    if (selectedSamples.size === 0) {
    
      return;
    }

    try {

    
      
     
      const items = Array.from(selectedSamples).map(variantId => {
        const id = parseInt(variantId, 10);
        if (isNaN(id)) {
          console.error('Invalid variant ID:', variantId);
          return null;
        }
        return {
          id: id,
          quantity: 1,
          properties: {
            'Sample': 'Yes'
          }
        };
      }).filter(Boolean); 
      
      if (items.length === 0) {
        console.error('No valid variant IDs found');
        alert('No valid samples selected. Please try again.');
        return;
      }

      const formData = { items };
    

    
      const cartAddUrl = window.Shopify?.routes?.root 
        ? window.Shopify.routes.root + 'cart/add.js' 
        : (window.shopUrl ? window.shopUrl + '/cart/add.js' : '/cart/add.js');
      
    

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const responseData = await response.json();
      
      if (!response.ok) {
        console.error('Cart add response error:', {
          status: response.status,
          statusText: response.statusText,
          data: responseData
        });
        console.error('Full response data:', JSON.stringify(responseData, null, 2));
        throw new Error(responseData.message || responseData.description || `HTTP ${response.status}: Failed to add items to cart`);
      }

    

      selectedSamples.clear();
      document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
        button.classList.remove('selected');
        button.textContent = 'Select Sample';
      });
      updateProgress();
      updateConfirmButton();

      await checkCartItems();

      closeSamplesDrawer();

      const cartDrawerResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await cartDrawerResponse.json();
      
      const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
      const sections = await fetch(window.Shopify.routes.root + `?sections=${sectionsToRender.join(',')}`);
      const sectionsData = await sections.json();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents({
          sections: sectionsData,
          id: null
        });
      }
    } catch (error) {
      console.error('Error adding samples to cart:', error);
   
      alert('There was an error adding samples to your cart. Please try again.');
    }
  }

  function initializeEventListeners() {
    document.addEventListener('click', async function(event) {
      const closeButton = event.target.closest('.samples-panel__close-button');
      const sampleButton = event.target.closest('.samples-panel__sample-button');
      const confirmButton = event.target.closest('.samples-panel__sample-button-atc');
      const openButton = event.target.closest('.samples-bar');

      if (closeButton) {
        closeSamplesDrawer();
      }
      else if (sampleButton) {
        handleSampleButtonClick(sampleButton);
      }
      else if (confirmButton && !confirmButton.classList.contains('disabled')) {
        await handleConfirmSelection();
      }
      else if (openButton) {
      
  
        selectedSamples.clear();
        document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
          button.classList.remove('in-cart', 'selected', 'limit-reached');
          button.disabled = false;
          button.textContent = 'Select Sample';
          button.closest('.samples-panel__sample')?.classList.remove('in-cart', 'limit-reached');
        });


        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          const cartData = await cartResponse.json();
         
          
   
          await checkCartItems();
          updateConfirmButton();
          
  
          openSamplesDrawer();
        } catch (error) {
        
          openSamplesDrawer();
        }
      }
    });


    document.addEventListener('cart:refresh', async function(event) {
      await checkCartItems();
      updateConfirmButton();
    });


    document.addEventListener('cart:open', async function(event) {
      await checkCartItems();
      updateConfirmButton();
    });


    document.addEventListener('cart:remove', async function(event) {
     
      await checkCartItems();
      updateConfirmButton();
      
   
      document.querySelectorAll('.samples-panel__sample-button').forEach(button => {
        const variantId = button.dataset.variantId;
        button.classList.remove('in-cart', 'selected', 'limit-reached');
        button.disabled = false;
        button.textContent = 'Select Sample';
        button.closest('.samples-panel__sample')?.classList.remove('in-cart', 'limit-reached');
        selectedSamples.delete(variantId);
      });

  
      try {
        const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
        const sections = await fetch(window.Shopify.routes.root + `?sections=${sectionsToRender.join(',')}`);
        const sectionsData = await sections.json();

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents({
            sections: sectionsData,
            id: null
          });
        }

       
        setTimeout(async () => {
        
          await checkCartItems();
        }, 500);
      } catch (error) {
      
      }
    });


    document.addEventListener('cart:update', async function(event) {
      await checkCartItems();
      updateConfirmButton();
    });

  
    document.addEventListener('cart:changed', async function(event) {
    
      await checkCartItems();
      updateConfirmButton();
    });

   
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
     
     
        setTimeout(async () => {
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`);
            const cartData = await response.json();
            await checkAndRemoveSampleProducts(cartData);
          } catch (error) {
          
          }
        }, 1000);
      });
    }

 
    document.addEventListener('change', async function(event) {
      if (event.target.matches('input[name="updates[]"]') || event.target.matches('.quantity__input')) {
       
        setTimeout(async () => {
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`);
            const cartData = await response.json();
            await checkAndRemoveSampleProducts(cartData);
          } catch (error) {
        
          }
        }, 1000);
      }
    });
  }


  window.CartSamples = {
    checkCartItems,
    checkAndRemoveSampleProducts,
    initializeEventListeners,
    openSamplesDrawer,
    closeSamplesDrawer
  };


  initializeEventListeners();

  
  checkCartItems();


  setTimeout(async () => {
    try {
    
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await response.json();
      await checkAndRemoveSampleProducts(cartData);
    } catch (error) {
    
    }
  }, 1000);


  window.testSampleRemoval = async function() {
   
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await response.json();
      await checkAndRemoveSampleProducts(cartData);
    } catch (error) {
    
    }
  };
});
